module.exports = __webpack_public_path__ + "static/media/Aug_2025_4.1d2f9836.webp";